import { render, staticRenderFns } from "./RecoverUsername.vue?vue&type=template&id=75295113"
import script from "./RecoverUsername.vue?vue&type=script&lang=ts"
export * from "./RecoverUsername.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports